export default __webpack_public_path__ + "static/media/circle-blue.8ac2dd51.svg";